import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
// import { AvatarComponent } from './avatar/avatar';
// import { DownloadDialogComponent } from './download-dialog/download-dialog';
// import { PropositionModalComponent } from './proposition-modal/proposition-modal';
// import { AddItemDialogComponent } from './add-item-dialog/add-item-dialog';
//import { ProfileIconComponent } from './profile-icon/profile-icon';
// import { LikeDialogComponent } from './like-dialog/like-dialog';
// import {  } from './dictionary/dictionary';
// import { DislikeDialogComponent } from './dislike-dialog/dislike-dialog';
//import { AddNewWordComponent } from './add-new-word/add-new-word';


@NgModule({
	declarations: [
		// AvatarComponent
		// DownloadDialogComponent
		// PropositionModalComponent
		// AddItemDialogComponent
		//ProfileIconComponent
		//LikeDialogComponent
		// DislikeDialogComponent
//        DictionaryComponent
//        AddNewWordComponent
//        TourGuideComponent,
//    WatchAdsComponent
//        AdsMessageComponent
//            WordItemComponent,
//            ChatInputComponent,
//            ItemComponent,
//            CollectionComponent,
//            MessageComponent,
//            PuzzleComponent,
//            LeitnerComponent,
//            NewsComponent,
//            PartnerComponent,
//            IdiomComponent,
//            QuizComponent,
//            NounComponent,
//            VerbComponent,
//            MemberComponent,
//            AddFriendDialogComponent,
        //    FriendComponent,
//            AddPersonDialogComponent,
//            ChatSegmentsComponent,
//            DebugDialogComponent,
//            SelectionLanguageComponent,
//            PhraseComponent,
//            ConjugationModalComponent,
//            ConjugationComponent,
//            DialogMenuOptionMessageComponent
			// SafePipePipe
		],
	imports: [

		IonicModule,
		CommonModule,
	],
	exports: [
		// AvatarComponent
		// DownloadDialogComponent
		//ChatOptionMenuComponent
		// PropositionModalComponent
		// AddItemDialogComponent
		//ProfileIconComponent
		//LikeDialogComponent
		// DislikeDialogComponent
//        DictionaryComponent
//        AddNewWordComponent
//        TourGuideComponent,
//    WatchAdsComponent
//        AdsMessageComponent
//            WordItemComponent,
//            ChatInputComponent,
//            ItemComponent,
//            CollectionComponent,
//            MessageComponent,
//            PuzzleComponent,
//            LeitnerComponent,
//            NewsComponent,
//            PartnerComponent,
//            IdiomComponent,
//            QuizComponent,
//            NounComponent,
//            VerbComponent,
//            MemberComponent,
//            AddFriendDialogComponent,
//            FriendComponent,
//            AddPersonDialogComponent,
//            ChatSegmentsComponent,
//            DebugDialogComponent,
//            SelectionLanguageComponent,
//            PhraseComponent,
//            ConjugationModalComponent,
//            ConjugationComponent,
//            DialogMenuOptionMessageComponent
        ]
})
export class ComponentsModule {}
